
import { selectMe } from 'app/slice/user.slice'
import _ from 'lodash'
import moment from 'moment'
import { useEffect, useReducer, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** COMPONENT */

/** CONSTANTS */

/** UTILS || SLICE */
import { getBranch } from 'utils/app.utils'

/** API */


/** STYLE */
import { faFolder, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Chip, ClickAwayListener, Grid, InputAdornment } from '@mui/material'
import AboutUs from 'api/admin/clinic-manage/about.api'
import FollowUpApi from 'api/follow-up.api'
import ClinicApi from 'api/master/clinic.api'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'
import SearchPatients from 'component/SearchPatients'
import { FollowUpPatientStatus, FollowUpStatusType, patientStatuses, patientStatusesFilter } from 'constants/patient-statuses'
import { colors } from 'constants/theme'
import * as UseStyled from 'features/home/UseStyled'
import CheckboxButton from 'new-components/buttons/checkbox-button'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AutocompleteSelect from 'new-components/select/autocomplete-select'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'
import SliderFollowUp from './sliderSliderFollowUp'
import ViewHistoryFollowUp from './view-history-follow-up'



export const defaultCaseDeats = [{ stage: 1, count: 0, rows: [] }, { stage: 2, count: 0, rows: [] }, { stage: 3, count: 0, rows: [] }, { stage: 4, count: 0, rows: [] }, { stage: 5, count: 0, rows: [] }]

const stageInfoMap = new Map();
patientStatusesFilter.forEach((item: any) => {
    if (Object.values(FollowUpStatusType).includes(item.key as FollowUpStatusType)) {
        stageInfoMap.set(item.typeId, item);
    }
});

export default function FollowUp() {
    const { t, i18n } = useTranslation()
    const user = useSelector(selectMe)
    const [hasCollapse, setHasCollapse] = useState(false)
    const [caseData, setCaseData] = useState(defaultCaseDeats);
    const [sendExam, setSendExam] = useState(false)
    const [branch, setBranch] = useState<any>()
    const [branchId, setBranchId] = useState<any>(getBranch())
    const [branches, setBranches]: any = useState<any[]>([])
    const momentNowRange = [moment().add(1, 'days').format('YYYY-MM-DD'), moment().add(1, 'days').format('YYYY-MM-DD')]
    const [rangeDate, setRangeDate] = useState<string[]>(momentNowRange)
    const [patientId, setPatientId] = useState<number>(0)
    const [selectedStatuses, setSelectedStatuses] = useState<any>([{ key: FollowUpPatientStatus.ALL, typeId: null, id: null, color: colors.lightGray, statusName: 'ทั้งหมด', statusNameEn: 'All' }])
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [search, setSearch] = useState('')
    const [fetch, setFetch] = useState<boolean>(false);
    const [loading, setLoading] = useState(false)
    const [patientFilter, setPatientFilter] = useState<string>(t('REPORT.REPORT_GROUP.ALL'))
    const [isShowModalHistory, setIsShowModalHistory] = useState(false)
    const [isSelectStatus, setIsSelectStatus] = useState<boolean>(false)
    const [followUpId, setFollowUpId] = useState<number>()
    const [isEdit, setIsEdit] = useState<boolean>()
    const [hasAppointment, setHasAppointment] = useState(false)
    const isFirstRun = useRef(true)
    const permissions = { isCreate: isCreate(), isDelete: isDelete(), isUpdate: isUpdate(), isView: isView() }
    const [totalCounts, setTotalCounts] = useState<{ [key: number]: number }>({})
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const isRequestingMore = useRef(false)




    const verifyPermission = async () => {
        ClinicApi.findAllBranches()
            .then(({ data }: any) => setBranches(data))
            .catch((e) => {
                return
            })

    }

    useEffect(() => {
        verifyPermission()
    }, [branchId])

    const loadBranchInfo = () => {
        AboutUs.detailClinic(Number(branchId))
            .then(({ data }) => { setBranch(data) })
            .catch((e) => { return })
    }

    useEffect(() => {
        loadBranchInfo()
    }, [branchId])

    useEffect(() => {
        if (isEdit !== undefined) {
            loadListFollowUp()
        }
    }, [isEdit])


    const loadListFollowUp = async (isLoadMore = false) => {
        if (isLoadMore) {
            setIsLoadingMore(true);
        } else {
            setLoading(true);
        }
        let condition: any = {};
        if (branchId) condition = { ...condition, branchId: branchId };
        if (search) condition = { ...condition, search: search };
        const stageAll = selectedStatuses
            .filter((v: any) => v.typeId !== null)
            .map((v: any) => v.typeId);
        const uniqueValues = [...new Set(stageAll)];
        const uniqueValuesKey = [...new Set(selectedStatuses.map((v: any) => v.key))];

        if (!_.isEmpty(selectedStatuses)) {
            const isSelectAll = selectedStatuses.some((v: any) => v.key === FollowUpPatientStatus.ALL);
            const finalStatuses =
                selectedStatuses
                    .filter((s: any) => !Object.values(FollowUpStatusType).includes(s.key as FollowUpStatusType))
                    .map((s: any) => s.key)
            const uniqueValuesKey = [...new Set(finalStatuses)].join(',');
            if (!isSelectAll && finalStatuses) {
                condition = { ...condition, status: uniqueValuesKey === 'ALL' ? '' : uniqueValuesKey, stage: uniqueValues.join(',') };
            }
        }
        if (rangeDate[0] !== null && rangeDate[0] !== '' && rangeDate[1] !== null && rangeDate[1] !== '') {
            condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] };
        }
        if (patientId) condition = { ...condition, patientId: patientId };
        if (page) condition = { ...condition, page: page };
        if (pageLimit) condition = { ...condition, pageLimit: pageLimit }; // ใช้ค่า pageLimit จาก state แทน hardcode
        if (hasAppointment) condition = { ...condition, hasAppointment: 0 }; // เมื่อติ๊ก 0 หากไม่ติก 1 หากไม่ส่ง 1
        try {
            const queue = await FollowUpApi.listFollowUp(condition);
            if (queue.status === 200 && !_.isEmpty(queue.data)) {
                if (isLoadMore) {
                    // Merge ข้อมูลใหม่กับข้อมูลเก่า
                    setCaseData((prevData) => {
                        return prevData.map((prevStage: any) => {
                            const newStage = queue.data.find((s: any) => s.stage === prevStage.stage);
                            if (newStage) {
                                // รวม rows ใหม่กับ rows เก่า (ไม่ให้ซ้ำ)
                                const existingIds = new Set(prevStage.rows.map((r: any) => r.followUpId || r.patientId));
                                const newRows = newStage.rows.filter((r: any) => !existingIds.has(r.followUpId || r.patientId));
                                return {
                                    ...prevStage,
                                    rows: [...prevStage.rows, ...newRows],
                                    count: newStage.count
                                };
                            }
                            return prevStage;
                        });
                    });
                } else {
                    setCaseData(queue.data);
                }
                // เก็บ total count ของแต่ละ stage
                setTotalCounts((prev) => {
                    const newCounts = { ...prev };
                    queue.data.forEach((stage: any) => {
                        newCounts[stage.stage] = stage.count || 0;
                    });
                    return newCounts;
                });
            } else {
                if (!isLoadMore) {
                    setCaseData(defaultCaseDeats);
                }
            }
        } catch (error) {
            if (!isLoadMore) {
                setCaseData(defaultCaseDeats);
            }
        } finally {
            setLoading(false);
            setIsLoadingMore(false);
        }
    };


    const handleCallback = (value: any) => {
        if (value.key === 'openVisit') {
            setSendExam(true)
        } else if (value.key === 'reloadListQueue' && value.value === 'success') {
            loadListFollowUp()
            handleClick()
        }
    }

    const dataAlert = useSelector((state: any) => state.modal.dataAlert)
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false
            return
        }
        loadListFollowUp()
    }, [dataAlert])


    useEffect(() => {
        if (fetch) {
            loadListFollowUp()
            setFetch(false)
        }
    }, [fetch])

    useEffect(() => {
        if (isFirstRun.current && !sendExam) {
            handleCallback({ key: 'reloadListQueue', value: 'success' })
        }
    }, [sendExam])


    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const handleClick = () => forceUpdate();

    useEffect(() => {
        loadListFollowUp()
        isFirstRun.current = true
        return () => {
            isFirstRun.current = false
        }
    }, [])


    // Load more data when page increases (triggered by scroll)
    useEffect(() => {
        if (isRequestingMore.current && page > 1) {
            loadListFollowUp(true).finally(() => {
                isRequestingMore.current = false;
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page])


    const renderOptionStatusStage = (option: any) => {
        if (option.key !== FollowUpPatientStatus.ALL) {
            return i18n.language === 'th' ? `Stage${option.typeId}: ${option.statusName}` : `Stage${option.typeId}: ${option.statusNameEn}`
        } else {
            return i18n.language === 'th' ? option.statusName : option.statusNameEn
        }
    }


    return (
        <div
            className={'service-points h-100 pb-4 d-flex flex-column'}
            style={{ overflow: 'auto' }}
        >
            <Loading show={loading} /> 
            <UseStyled.Container>
                <Box sx={{ paddingY: '16px' }}>
                    <Grid container spacing="8px ">
                        <Grid item xs={12} sm={6} md={3} xl={2}>
                            <SelectInput
                                label={t('REPORT.FILTER.BRANCH')}
                                value={branchId}
                                onChange={e => {
                                    setBranchId(Number(e.target.value));
                                }}
                                options={[
                                    ...branches.map((b: any) => ({
                                        value: b.branchId,
                                        name: b.branchName || b.branchNameEn || ''
                                    }))]}
                                width="100%"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} xl={2}>
                            <TextInput
                                label={t('ค้นหา ชื่อคอร์ส / ชื่อหัตถการ')}
                                value={search}
                                onChange={(event) => {
                                    setSearch(event.target.value)
                                }}
                                fullWidth
                                inputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" >
                                            {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                                <FontAwesomeIcon
                                                    icon={faTimes}
                                                    onClick={() => {
                                                        setSearch('');
                                                    }}
                                                    style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} xl={2}>
                            <ClickAwayListener onClickAway={() => setIsSelectStatus(false)}>
                                <Box onClick={() => setIsSelectStatus(true)}>
                                    <AutocompleteSelect
                                        open={isSelectStatus}
                                        onOpen={(event, value) => setIsSelectStatus(true)}
                                        onClose={(event, value) => setIsSelectStatus(false)}
                                        multiple
                                        labelId="patient-status-select"
                                        inputLabel={t('STATUS.LABEL')}
                                        noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                                        options={patientStatusesFilter}
                                        value={selectedStatuses}
                                        sxAutoComplete={{
                                            '.MuiOutlinedInput-root': {
                                                height: 41,
                                            },
                                        }}
                                        onchange={(event, newValue, reason, details) => {

                                            const option = details?.option;
                                            if (!option) {
                                                setSelectedStatuses([]);
                                                return;
                                            }
                                            if (option.key === FollowUpPatientStatus.ALL) {
                                                const isAllCurrentlySelected = selectedStatuses.some((s: any) => s.key === FollowUpPatientStatus.ALL);
                                                setSelectedStatuses(isAllCurrentlySelected ? [] : [option]);
                                                return;
                                            }
                                            const wasAllSelected = selectedStatuses.some((s: any) => s.key === FollowUpPatientStatus.ALL);
                                            const isStage = Object.values(FollowUpStatusType).includes(option.key as FollowUpStatusType);

                                            if (wasAllSelected) {
                                                const allItems = patientStatusesFilter.filter((s: any) => s.key !== FollowUpPatientStatus.ALL);
                                                if (isStage) {
                                                    const remaining = allItems.filter((s: any) => s.typeId !== option.typeId);
                                                    setSelectedStatuses(remaining);
                                                } else {
                                                    const remaining = allItems.filter((s: any) => s.id !== option.id);
                                                    const stageHeader = stageInfoMap.get(option.typeId);
                                                    const final = remaining.filter((s: any) => s.key !== stageHeader?.key);
                                                    setSelectedStatuses(final);
                                                }
                                                return;
                                            }

                                            if (isStage) {
                                                const stageTypeId = option.typeId;
                                                const groupItems = patientStatusesFilter.filter((s: any) => s.typeId === stageTypeId);
                                                if (reason === 'selectOption') {
                                                    const prevWithoutGroup = selectedStatuses.filter((s: any) => s.typeId !== stageTypeId);
                                                    setSelectedStatuses([...prevWithoutGroup, ...groupItems]);
                                                } else {
                                                    const remaining = selectedStatuses.filter((s: any) => s.typeId !== stageTypeId);
                                                    setSelectedStatuses(remaining);
                                                }
                                            } else {
                                                if (reason === 'selectOption') {
                                                    const allChildrenInGroup = patientStatusesFilter.filter((s: any) =>
                                                        s.typeId === option.typeId && !Object.values(FollowUpStatusType).includes(s.key)
                                                    );
                                                    const selectedChildren = newValue.filter((s: any) =>
                                                        s.typeId === option.typeId && !Object.values(FollowUpStatusType).includes(s.key)
                                                    );

                                                    if (allChildrenInGroup.length === selectedChildren.length) {
                                                        const stageHeader = stageInfoMap.get(option.typeId);
                                                        const hasHeader = newValue.some((s: any) => s.key === stageHeader.key);
                                                        if (stageHeader && !hasHeader) {
                                                            setSelectedStatuses([...newValue, stageHeader]);
                                                            return;
                                                        }
                                                    }
                                                    setSelectedStatuses(newValue);
                                                } else if (reason === 'removeOption') {
                                                    const stageHeader = stageInfoMap.get(option.typeId);
                                                    const filtered = newValue.filter((s: any) => s.id !== stageHeader?.id);
                                                    setSelectedStatuses(filtered);
                                                } else {
                                                    setSelectedStatuses(newValue);
                                                }

                                            }

                                        }}
                                        getOptionLabel={(option) => i18n.language === 'th' ? option.statusName : option.statusNameEn}
                                        isOptionEqualToValue={(option: any, value: any) => {
                                            if (option.key === FollowUpPatientStatus.ALL || value.key === FollowUpPatientStatus.ALL) {
                                                return option.key === value.key;
                                            }
                                            return option.id === value.id;
                                        }}
                                        renderOption={(props, option, { selected }) => {
                                            const isStage = Object.values(FollowUpStatusType).includes(option.key as FollowUpStatusType);
                                            const isAllSelected = selectedStatuses.some((s: any) => s.key === FollowUpPatientStatus.ALL);
                                            const isHighlighted = isAllSelected || selectedStatuses.some((s: any) => s.id === option.id);
                                            return (
                                                <Box
                                                    component="li"
                                                    {...props}
                                                    key={option.id}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        fontWeight: option.key === FollowUpPatientStatus.ALL ? 'bold' : 'normal',
                                                        paddingLeft: isStage || option.key === FollowUpPatientStatus.ALL ? '16px' : '32px',
                                                        backgroundColor: selected ? colors.themeSecondColor06 : 'transparent',
                                                        color: isHighlighted ? colors.themeSecondColor : colors.black,
                                                    }}
                                                >
                                                    {!(isStage || option.key === FollowUpPatientStatus.ALL) && (
                                                        <Box component="span" sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: option.color, mr: 1.5, flexShrink: 0 }} />
                                                    )}
                                                    <Box component="span" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {i18n.language === 'th' ? option.statusName : option.statusNameEn}
                                                    </Box>
                                                </Box>
                                            );
                                        }}
                                        renderTags={(value, getTagProps, ownerState) => {
                                            const filteredValue = value.filter((v: any) => !Object.values(FollowUpStatusType).includes(v.key as FollowUpStatusType));
                                            return ownerState.focused ?
                                                (
                                                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto' }}>
                                                        {
                                                            filteredValue.map((option: any, index: any) => (
                                                                <Chip
                                                                    {...getTagProps({ index })}
                                                                    key={option.id}
                                                                    label={renderOptionStatusStage(option)}
                                                                    style={{
                                                                        backgroundColor: option.color,
                                                                        color: option.key === 'ALL' ? colors.black : colors.white,
                                                                        fontSize: '14px',
                                                                        height: '24px',
                                                                        flexShrink: 0
                                                                    }}
                                                                />
                                                            ))
                                                        }
                                                    </Box>
                                                ) : filteredValue.map((option: any, index: any) => (
                                                    <Chip
                                                        {...getTagProps({ index })}
                                                        key={option.id}
                                                        label={renderOptionStatusStage(option)}
                                                        style={{ backgroundColor: option.color, color: option.key === 'ALL' ? colors.black : colors.white, fontSize: '14px', height: '24px' }}
                                                    />
                                                ));
                                        }}
                                        limitTags={1}
                                    />
                                </Box>
                            </ClickAwayListener>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} xl={2}>
                            <InputSecondNewRangePicker
                                inputHeight={41}
                                value={rangeDate || emptyRangePicker}
                                onchange={(val: any) => {
                                    if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                                    else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                                }}
                                label={`${t('ช่วงวันที่นัดหมาย เริ่มต้น')}  »  ${t('สิ้นสุด')}`}
                                onClear={() => setRangeDate(emptyRangePicker)}
                                // allowClear
                                disabled={hasAppointment}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} xl={3}>
                            <SearchPatients
                                status="ACTIVE"
                                callbackPatientId={setPatientId}
                                patientId={patientId}
                                onClear={() => setPatientId(0)}
                                bodyHeight={40}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2} xl={1}>
                            <MainButton
                                onClick={() => {
                                    setFetch(true)
                                    setPage(1)
                                    setPageLimit(10) // Reset pageLimit เมื่อค้นหาใหม่
                                    setLoading(true)
                                }}
                                title={t('INPUT.SEARCH')}
                                type='primary'
                                variant='contained'
                                style={{ width: '120px' }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} xl={6}>
                            <CheckboxButton
                                onChange={(e) => {
                                    if (e?.target?.checked) setRangeDate(['', ''])
                                    else setRangeDate(momentNowRange)
                                    setHasAppointment(e?.target?.checked)
                                    setPage(1)
                                    setPageLimit(10)
                                    setFetch(true)
                                }}
                                label={t('แสดงการ์ดที่ไม่มีนัดหมาย')}
                                checked={hasAppointment}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} xl={6} display={'flex'} justifyContent={'flex-end'}>
                            <MainButton
                                onClick={() => {
                                    setIsShowModalHistory(true)
                                }}
                                title={t('ประวัติเคสที่จบแล้ว')}
                                type='primary'
                                variant='outlined'
                                startIcon={<FontAwesomeIcon icon={faFolder} />}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </UseStyled.Container>
            {/* overflow-hidden */}
            <UseStyled.Container className={'pr-0 h-100'} style={{ position: 'relative' }}>
                <SliderFollowUp
                    branch={branch}
                    service={caseData}
                    hasCollapse={hasCollapse}
                    setCancelCase={handleCallback}
                    reRender={() => {
                        loadListFollowUp()
                    }}
                    setFollowUpId={setFollowUpId}
                    followUpId={followUpId}
                    isEdit={isEdit}
                    onLoadMore={() => {
                        if (!isLoadingMore && !loading && !isRequestingMore.current) {
                            const hasMoreData = caseData.some((stage: any) => {
                                const totalCount = totalCounts[stage.stage] || stage.count || 0;
                                const currentRows = stage.rows?.length || 0;
                                return totalCount > currentRows;
                            });
                            if (hasMoreData) {
                                isRequestingMore.current = true;
                                setPage((prev) => prev + 1);
                            }
                        }
                    }}
                    isLoadingMore={isLoadingMore}
                    loading={loading}
                    totalCounts={totalCounts}
                />
            </UseStyled.Container>
            {isShowModalHistory && <ViewHistoryFollowUp
                onClose={() => setIsShowModalHistory(false)}
                onEdit={(followUpId: number, isEdit: boolean) => {
                    setFollowUpId(followUpId)
                    setIsEdit(isEdit)
                    if (isEdit) setIsShowModalHistory(!isEdit)
                }}
                disabled={permissions.isUpdate.disabled}
            />}
        </div >
    )
}

export { StatusSelectorCustom, DropdownToggle } from './follow-up-status-selector'
